import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
import { IconArrowDown } from '../../../icons/svg';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column'
        },
        label: {
            color: theme.palette.selectLabel,
            ...theme.typography.bodyShortRegular,
            marginBottom: theme.spacing(2),
            '&.is-mobile': {
                ...theme.typography.bodyShortRegularLarge
            }
        },
        selectContainer: {
            position: 'relative'
        },
        select: {
            backgroundColor: '#2F3850',
            borderRadius: `12px`,
            width: '100%',
            ...theme.typography.bodyShortRegular,
            color: theme.palette.selectText,
            padding: '10px 16px',
            paddingRight: '42px',
            border: 0,
            appearance: 'none',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&:focus': {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.selectFocus}`
            },
            '&:disabled': {
                color: theme.palette.selectDisabled
            },
            '&.is-mobile': {
                ...theme.typography.bodyShortRegularLarge,
                padding: '12px 16px',
                paddingRight: '46px'
            },
            '&.error': {
                boxShadow: `0px 0px 0px 2px ${theme.palette.selectError}`
            }
        },
        icon: {
            position: 'absolute',
            top: '8px',
            right: '8px',
            pointerEvents: 'none',
            '&.is-mobile': {
                top: '12px',
                right: '12px'
            }
        },
        bottomLabel: {
            marginTop: theme.spacing(2),
            ...theme.typography.labelRegular,
            color: theme.palette.selectBottomLabel,
            '&.is-mobile': {
                ...theme.typography.bodyShortRegular
            },
            '&.error': {
                color: theme.palette.selectBottomLabelError
            }
        }
    };
});
const Select = ({ bottomLabel, containerClassName, className, disabled, error, id, label, onChange, options, value }) => {
    const { classes, cx, theme } = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("div", { className: cx(classes.container, containerClassName) },
        label && React.createElement("label", { className: cx(classes.label, isMobile && 'is-mobile'), htmlFor: id }, label),
        React.createElement("div", { className: classes.selectContainer },
            React.createElement("select", { "aria-describedby": bottomLabel ? `${id}-description` : undefined, className: cx(classes.select, isMobile && 'is-mobile', className, error && 'error'), disabled: disabled, id: id, onChange: onChange, value: value }, options.map(option => (React.createElement("option", { key: option.value, value: option.value }, option.label)))),
            React.createElement(Icon, { className: cx(classes.icon, isMobile && 'is-mobile'), color: disabled ? theme.palette.selectIconDisabled : theme.palette.selectIcon, size: 22, src: IconArrowDown })),
        bottomLabel && (React.createElement("span", { className: cx(classes.bottomLabel, isMobile && 'is-mobile', error && 'error'), id: `${id}-description` }, bottomLabel))));
};
export default Select;
